"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const header_app_1 = require("./header-app");
const content_app_1 = require("./content-app");
exports.render = ({ data, translate, replaceVariables, trackEvent, openMediaDbApi, tabs, validate, headerContainer, contentContainer, editableId, }) => {
    const contentEmit = content_app_1.renderContentApp({
        container: contentContainer,
        translate,
        data,
        trackEvent,
        validate,
        replaceVariables,
        openMediaDbApi,
        editableId,
        tabs,
    });
    header_app_1.renderHeaderApp({
        container: headerContainer,
        tabs,
        editableId,
        onTabChange: tabName => contentEmit('changeTab', { tabName: tabName }),
    });
    return () => contentEmit('export');
};
//# sourceMappingURL=image-properties-app.js.map